/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import toReact from 'svelte-adapter/react'
import GoogleAnalytics from 'react-ga'
import Dialogs from 'webkit/ui/Dialog/Dialogs.svelte'
import { track } from 'webkit/analytics'
import { initTwitterPixel } from 'webkit/analytics/twitter'
import { initAmplitude } from 'webkit/analytics/amplitude'
import { trackLink } from 'webkit/analytics/events/general'
import { startResponsiveController } from 'webkit/responsive'
import { useExperiment } from '@marvelapp/react-ab-test'
import { MixpanelContext } from '../apollo/wrap-root-element'
import StripeProviderSSR from './StripeProviderSSR'
import Intercom from './Intercom'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Notifications from './Notifications/Notifications'
import CookiePopup from './CookiePopup/CookiePopup'
import TopPanel from './TopPanel'
import BannerComponent from './Banner/index.svelte'
import styles from './layout.module.scss'
import 'webkit/styles/main.css'

const Banner = toReact(BannerComponent, {}, 'div')

if (process.browser) {
  startResponsiveController()
  initAmplitude()

  const root = document.documentElement

  root.addEventListener('click', e => {
    // Adapted from https://github.com/visionmedia/page.js
    // MIT license https://github.com/visionmedia/page.js#license
    const { button, metaKey, ctrlKey, shiftKey, altKey, defaultPrevented } = e
    if (button) return
    if (metaKey || ctrlKey || shiftKey || altKey) return
    if (defaultPrevented) return

    const target = e.target
    if (!target) return

    const anchor = target.closest('a')
    if (!anchor) return

    const href = anchor.getAttribute('href') || ''
    const isExternal = href.startsWith('http')
    const { type, source } = anchor.dataset

    if (isExternal) {
      e.preventDefault()
      window.open(href, '_blank').focus()
    }

    trackLink({ url: href, external: isExternal, type, source })
  })
}

if (process.env.NODE_ENV === 'production') {
  GoogleAnalytics.initialize('UA-100571693-8')

  if (typeof window !== 'undefined') {
    initTwitterPixel()
  }
} else {
  GoogleAnalytics.initialize('UA-100571693-8', { testMode: true })
}

const Layout = ({ children, isAccountPage, classes = {} }) => {
  const mixpanel = useContext(MixpanelContext)
  const { selectVariant, emitWin, activeVariant } = useExperiment(
    'SanApi Questionnaire'
  )

  const variant = selectVariant({
    Questionnaire: (
      <>
        <TopPanel />
        <Banner />
      </>
    ),
    Old: <></>,
  })

  useEffect(() => {
    track.pageview('api.santiment.net')
    emitWin('SanApi Questionnaire')
    // TODO: Uncomment after prod test
    // mixpanel.track('SanApi Questionnaire' + ' ' + activeVariant, {
    //   name: 'SanApi Questionnaire',
    //   variant: activeVariant,
    // })

    const svelte = new Dialogs({ target: document.body })
    return () => svelte.$destroy()
  }, [])

  return (
    <StripeProviderSSR>
      <Intercom>
        <Notifications>
          <div className={styles.container}>
            {variant}
            <Header isAccountPage={isAccountPage} />
            <main className={cx(styles.main, classes.main)}>{children}</main>
            <Footer />
          </div>
        </Notifications>
        <CookiePopup />
      </Intercom>
    </StripeProviderSSR>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
